import { ApiStateRecord } from '@exxonmobil/uit-uda-ui-components-lib';
import { WorkCenterBaseline } from 'models/baselines';
import { approveWorkCenterBaselines } from 'services/baselines.service';
import { handleAllUpdatesToApi } from './updateRecord';

/*
  for all of the checked elements, make an api call for each to set requested to an empty array.
  Show progress message during the updating.
  Update the main state array with these results.
*/
export const approveSelected = async (
  currentState: ApiStateRecord<WorkCenterBaseline[]>
) => {
  const selectedBaselines = currentState.state.data.filter((b) => b.isSelected);

  currentState.setState({
    ...currentState.state,
    loading: false
  });

  const promises: Promise<Response>[] = selectedBaselines.map((baseline) =>
    approveWorkCenterBaselines(baseline.id as string)
  );

  const promiseResults: PromiseSettledResult<Response>[] = [];

  await Promise.allSettled(promises).then((results) => {
    promiseResults.push(...handleAllUpdatesToApi(results, currentState));
  });
  return promiseResults;
};
